var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLocation = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.9102,
    cy: 19.108,
    r: 19,
    fill: "#ACCE42"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.1562 15.764C26.1562 19.196 20.9202 28.524 19.9082 28.524C18.9402 28.524 13.6602 19.24 13.6602 15.764C13.6602 12.288 16.4762 9.55997 19.9082 9.55997C23.3402 9.55997 26.1562 12.332 26.1562 15.764Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2526 14.708C23.2966 14.972 23.3406 15.236 23.3406 15.5C23.3406 17.392 21.8006 18.932 19.9086 18.932C18.0166 18.932 16.4766 17.392 16.4766 15.5C16.4766 13.608 18.0166 12.068 19.9086 12.068C20.2166 12.068 20.4806 12.112 20.7446 12.156",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.910156 0.107971H38.9102V38.108H0.910156V0.107971Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.91016,
    y: 8.10797,
    width: 22,
    height: 22,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLocation, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Location.65c8a901.svg";
export { ForwardRef as ReactComponent };